import {
  Button,
  FormControl,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import HttpClient from "libs/utils/HttpClient";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DatetimeService from "services/DatetimeService";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpTabs: {
    marginTop: 30,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
    marginRight: 10,
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },
  warpData: {
    marginTop: 20,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: "#1094D8",
    color: "white",
  },
  iconStatus: {
    color: "#2DCE98",
    marginRight: 5,
  },
  warpButtonSave: {
    textAlign: "right",
    marginTop: 30,
  },
  buttonSave: {
    marginLeft: 5,
    width: 120,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  wrapDateControl: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: 15,
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  dateControl: {
    marginRight: 5,
    width: "100%",
  },
  btnEdit: {
    color: "white",
    backgroundColor: "#2DCE98",
    marginLeft: 10,
  },
  btnRemove: {
    color: "white",
    backgroundColor: "#1094d8",
    marginLeft: 10,
  },
  warpRowDialog: {
    marginTop: 10,
  },
  dtitle: {
    color: "#40B8D4",
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
}));

function EmailLogPage() {
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const dispatch = useDispatch();
  //   const { list: holidays } = useSelector((state) => state.holiday);
  const [email_data, setEmail_data] = useState([]);
  const [date, setDate] = React.useState(new Date());
  const [dialogData, setDialogData] = React.useState(false);
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const history = useHistory();
  const flDate = DatetimeService.getFirstAndLastDayOfMonth(new Date());

  useEffect(async () => {
    try {
      const response = await HttpClient.get(
        `/api/mail/list?startDate=${startDate}&endDate=${endDate}`
      );

      setEmail_data(response.results);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }, []);

  useEffect(() => {
    setStartDate(flDate?.firstDate);
    setEndDate(flDate?.lastDate);
    getListByDate(flDate?.firstDate, flDate?.lastDate);
  }, []);

  const getListByDate = async (start, end) => {
    try {
      const response = await HttpClient.get(
        `/api/mail/list?startDate=${moment(start).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(end).format("YYYY-MM-DD")}`
      );

      if (response.status) {
        setEmail_data(response.results);
        return response;
      } else {
        setEmail_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const ResendEmail = async (id) => {
    const data = {
      logEmailID: id,
    };
    try {
      const response = await HttpClient.post("/api/mail/resend", data);
      console.log(response);
      if (response.status) {
        alert(response.message);
      } else {
        alert(response.message);
      }
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const FilterSubject = (e) => {
    if (e !== "") {
      if (email_data) {
        const filter = email_data.filter((item) => {
          return item.subject.toLowerCase().includes(e.toLowerCase());
        });
        setEmail_data(filter);
      }
    } else {
      setTimeout(function () {
        getListByDate(startDate, endDate);
      }, 500);
    }
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Email Log" />

      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="Email Log" />
        <div className={classes.wrapDateControl}>
          <FormControl variant="outlined" className={clsx(classes.dateControl)}>
            <DatePicker
              label="Start Date"
              value={startDate}
              format="DD-MM-YYYY"
              onChange={async (_date) => {
                setStartDate(_date.format("YYYY-MM-DD"));
                // console.log(_date.format("YYYY-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </FormControl>
          <FormControl variant="outlined" className={clsx(classes.dateControl)}>
            <DatePicker
              label="End Date"
              format="DD-MM-YYYY"
              value={endDate}
              onChange={async (_date) => {
                setEndDate(_date.format("YYYY-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </FormControl>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            className={classes.buttonDialogSave}
            onClick={() => {
              getListByDate(startDate, endDate);
            }}
          >
            ค้นหา
          </Button>
        </div>
      </div>

      <div>
        <TextField
          onChange={(e) => FilterSubject(e.target.value)}
          label="Search Subject"
          variant="outlined"
        />
      </div>
      {email_data?.length !== 0 ? (
        <div>
          <Typography style={{ marginTop: 5 }}>
            จำนวนข้อมูลทั้งหมด : {email_data?.length}
          </Typography>
        </div>
      ) : null}
      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200, textAlign: "center" }}
                >
                  Date
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Subject
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Email To
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Status
                </StyledTableCell>
                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200, textAlign: "center" }}
                >
                  Manage
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {}
              {email_data !== null
                ? email_data.map((row, index) => (
                    <StyledTableRow key={row.logEmailID}>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        style={{ textAlign: "center" }}
                      >
                        {row.mailDate
                          ? format(new Date(row.mailDate), "yyyy-MM-dd")
                          : null}
                      </StyledTableCell>
                      <StyledTableCell>{row.subject}</StyledTableCell>
                      <StyledTableCell>{row.mailTo}</StyledTableCell>
                      <StyledTableCell>{row.statusName}</StyledTableCell>

                      <StyledTableCell>
                        <div className={classes.warpButtonDetail}>
                          <Button
                            size="small"
                            color="primary"
                            className={classes.btnEdit}
                            onClick={async () => {
                              console.log(email_data[index]);
                              history.push("/admin/setting/emailDetail", {
                                data: email_data[index],
                              });
                            }}
                          >
                            View
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            className={classes.btnRemove}
                            onClick={async () => {
                              ResendEmail(row.logEmailID);
                            }}
                          >
                            Resend
                          </Button>
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        {email_data?.length === 0 ? <center>No Record</center> : null}
      </div>
    </Paper>
  );
}

export default EmailLogPage;
